import get from 'lodash/get';

function validateNodeConnections(caseConf, nodeInfo, { isEffectChain }) {
  if (isEffectChain) {
    return;
  }
  const errors = [];
  const warnings = [];

  nodeInfo.actionNodes.forEach(node => {
    if (!get(node, 'outputs.targets.connections.length')) {
      warnings.push({
        message:
          'Node will have no affect on Sim. It is not connected to other nodes.',
        category: 'caseLogic',
        field: 'caseLogicDescription',
        id: node.id,
        metadata: {
          nodeId: node.id,
          scope: 'node',
          defaultVisibility: false,
        },
      });
    }
  });

  nodeInfo.timerNodes.forEach(node => {
    if (!get(node, 'outputs.targets.connections.length')) {
      warnings.push({
        message:
          'Node will have no affect on Sim. It is not connected to other nodes.',
        category: 'caseLogic',
        field: 'caseLogicDescription',
        id: node.id,
        metadata: {
          nodeId: node.id,
          scope: 'node',
          defaultVisibility: false,
        },
      });
    }
  });

  nodeInfo.effectNodes.forEach(node => {
    if (!get(node, 'inputs.inputs.connections.length')) {
      warnings.push({
        message:
          'Node will have no affect on Sim. It is not connected to other nodes.',
        category: 'caseLogic',
        field: 'caseLogicDescription',
        id: node.id,
        metadata: {
          nodeId: node.id,
          scope: 'node',
          defaultVisibility: false,
        },
      });
    }
  });

  nodeInfo.checkNodes.forEach(node => {
    if (!get(node, 'inputs.inputs.connections.length')) {
      warnings.push({
        message:
          'Node will have no affect on Sim. It is not connected to other nodes.',
        category: 'caseLogic',
        field: 'caseLogicDescription',
        id: node.id,
        metadata: {
          nodeId: node.id,
          scope: 'node',
          defaultVisibility: false,
        },
      });
    }
    else if (!get(node, 'outputs.trueOutputs.connections.length') && !get(node, 'outputs.falseOutputs.connections.length')) {
      warnings.push({
        message:
          'Node will have no affect on Sim. It is not connected to other nodes.',
        category: 'caseLogic',
        field: 'caseLogicDescription',
        id: node.id,
        metadata: {
          nodeId: node.id,
          scope: 'node',
          defaultVisibility: false,
        },
      });
    }
  });

  return {
    errors,
    warnings,
  };
}

export default validateNodeConnections;
